<template>
  <ls-table-layout>
    <div class="table-page-search-wrapper" slot="search">
      <a-form layout="inline" :labelCol="{ style: { width: '80px' } }">
        <a-row>
          <a-col :md="6" :sm="24">
            <a-form-item label="班次名称">
              <a-select v-model="queryParams.shiftsHeadId" @change="shiftsHeadIdOnChange">
                <a-select-option v-for="(item) in shiftsHeadIdListOption" :key="item.realValue">{{ item.label }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="说明">
              <a-input v-model="queryParams.description" />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <span class="table-page-search-submitButtons">
              <a-button @click="handleQuery" type="primary">查询</a-button>
              <a-button @click="resetQuery" class="ml8">重置</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <div class="table-page-operator-wrapper" slot="btn">
      <a-button @click="$refs.createModal.show()" type="primary" v-hasPermi="['bom:routingCalendar:addShiftsHead']">新增班次</a-button>
      <a-button :disabled="isEdit" @click="handleAddLine()" type="primary" v-hasPermi="['bom:routingCalendar:addShifts']">新增行</a-button>
    </div>
    <template v-slot:table>
      <div class="page-header-content">
        <!-- 表格 -->
        <!-- <a-table
          ref="table"
          :columns="columns"
          :loading="pageParams.tableLoading"
          :data-source="typeList"
          :pagination="false"
          :scroll="{ x: scrollWdith }"
          row-key="id"
        >
          <template slot="startTimeShifts" slot-scope="text, record">
            <span v-if="!isEdit || currentId !== record.id">{{ text && $moment(text).format('HH:mm:ss') }}</span>
            <a-time-picker v-if="isEdit && currentId === record.id" v-model="record.startTimeShifts" @change="startTimeShiftsOnChange" />
          </template>
          <template slot="endTimeShifts" slot-scope="text, record">
            <span v-if="!isEdit || currentId !== record.id">{{ text && $moment(text).format('HH:mm:ss') }}</span>
            <a-time-picker v-if="isEdit && currentId === record.id" v-model="record.endTimeShifts" @change="endTimeShiftsOnChange" />
          </template>
          <template slot="pauseDurationStandard" slot-scope="text, record">
            <span v-if="!isEdit || currentId !== record.id">{{ text }}</span>
            <a-input-number v-if="isEdit && currentId === record.id" v-model="record.pauseDurationStandard" :min="0" @change="pauseDurationStandardChange" />
          </template>
          <template slot="notes" slot-scope="text, record">
            <span v-if="!isEdit || currentId !== record.id">{{ text }}</span>
            <a-input v-if="isEdit && currentId === record.id" v-model="record.notes" />
          </template>
          <template slot="workingHours" slot-scope="text, record">
            <span v-if="!isEdit || currentId !== record.id">{{ text }}</span>
            <a-input v-if="isEdit && currentId === record.id" v-model="record.workingHours" disabled />
          </template>
          <span slot="operation" slot-scope="text, record">
            <a v-if="!isEdit || currentId !== record.id" @click="handleEdit(record)" v-hasPermi="['bom:routingCalendar:edit']">编辑</a>
            <a v-if="!isEdit || currentId !== record.id" class="ml10" @click="handleDelete(record)" v-hasPermi="['bom:routingCalendar:removeShifts']">删除</a>
            <a v-if="isEdit && currentId === record.id" @click="handleSave(record)">保存</a>
            <a v-if="isEdit && currentId === record.id" @click="handleCancel(record)" class="ml10">取消</a>
          </span>
        </a-table> -->
        <ls-api-table
          ref="dataTable"
          :columns="columns"
          :tableProps="tableProps"
          rowKey="id"
          :scroll="{ fixScreen: true, x: 1300 }"
          :toolBox="{
                density: true, // 传入String时 初始化默认表格密度
                fullScreen: false,  // 是否需要全屏
                configKey: $TableKey.FREQUENCY_INFORMATION_LIST, // 表格方案配置唯一值
              }"
        >
          <template slot="startTimeShifts" slot-scope="text">
            <span v-if="!isEdit || currentId !== text.record.id">{{ text.text && $moment(text.text).format('HH:mm:ss') }}</span>
            <a-time-picker v-if="isEdit && currentId === text.record.id" v-model="text.record.startTimeShifts" @change="(time, timeString) => startTimeShiftsOnChange(time, timeString, text.record)" />
          </template>
          <template slot="endTimeShifts" slot-scope="text">
            <span v-if="!isEdit || currentId !== text.record.id">{{ text.text && $moment(text.text).format('HH:mm:ss') }}</span>
            <EndTimePicker v-if="isEdit && currentId === text.record.id" :start-time="new Date(text.record.startTimeShifts)" v-model="text.record.endTimeShifts" @change="(time, timeString) => endTimeShiftsOnChange(time, timeString, text.record)" />
          </template>
          <template slot="pauseDurationStandard" slot-scope="text">
            <span v-if="!isEdit || currentId !== text.record.id">{{ text.text }}</span>
            <a-input-number v-if="isEdit && currentId === text.record.id" v-model="text.record.pauseDurationStandard" :min="0" @change="(str) => pauseDurationStandardChange(str, text.record)" />
          </template>
          <template slot="notes" slot-scope="text">
            <span v-if="!isEdit || currentId !== text.record.id">{{ text.text }}</span>
            <a-input v-if="isEdit && currentId === text.record.id" v-model="text.record.notes" />
          </template>
          <template slot="workingHours" slot-scope="text">
            <span v-if="!isEdit || currentId !== text.record.id">{{ text.text }}</span>
            <a-input v-if="isEdit && currentId === text.record.id" v-model="text.record.workingHours" disabled />
          </template>
          <span slot="operation" slot-scope="text">
            <a v-if="!isEdit || currentId !== text.record.id" @click="handleEdit(text.record)" v-hasPermi="['bom:routingCalendar:edit']">编辑</a>
            <a v-if="!isEdit || currentId !== text.record.id" class="ml10" @click="handleDelete(text.record)" v-hasPermi="['bom:routingCalendar:removeShifts']">删除</a>
            <a v-if="isEdit && currentId === text.record.id" @click="handleSave(text.record)">保存</a>
            <a v-if="isEdit && currentId === text.record.id" @click="handleCancel(text.record)" class="ml10">取消</a>
          </span>
        </ls-api-table>
        <!-- 底部分页按钮 -->
        <!-- <Page ref="page" :pageParams.sync="pageParams" @getList="getList" /> -->
        <!-- 创建/编辑快码,单独封装了组件 -->
        <frequency-information-add
          ref="createModal"
          @handle-success="handleOk"
        />
      </div>
    </template>
  </ls-table-layout>
</template>

<script>
import { apiRoutingCalendarShiftsPullDownList, apiRoutingCalendarAddShifts, apiRoutingCalendarRemoveShifts, apiRoutingCalendarListShifts } from '@/api/mes/calendar/frequencyInformation'
import FrequencyInformationAdd from './components/frequency-information-add'
import moment from 'moment';
import { generateLsTableResData } from '@/utils/util.js';
import EndTimePicker from '@/components/EndTimePicker/EndTimePicker';
import { calculateTimeDifference } from '@/utils/time'

export default {
  name: 'FrequencyInformation',
  components: {
    FrequencyInformationAdd,
    EndTimePicker
  },
  data () {
    return {
      // 表格配置
      tableProps: {
        requestApi: generateLsTableResData(apiRoutingCalendarListShifts, true),
        pageCurrent: true
      },
      pageParams: {
        automatic: false,
        pageUrl: '/bom/routingCalendar/listShifts',
        tableLoading: false
      },
      isEdit: false,
      currentId: "",
      // 查询参数
      queryParams: {
        shiftsHeadId: undefined,
        description: undefined
      },
      // 快码表格数据
      typeList: [],
      // 表格字段
      columns: [
        {
          title: '起始时间',
          dataIndex: 'startTimeShifts',
          width: 150,
          scopedSlots: { customRender: 'startTimeShifts' },
          align: 'center'
        },
        {
          title: '终止时间',
          dataIndex: 'endTimeShifts',
          width: 150,
          scopedSlots: { customRender: 'endTimeShifts' },
          align: 'center'
        },
        {
          title: '标准停顿时长（分）',
          dataIndex: 'pauseDurationStandard',
          width: 150,
          scopedSlots: { customRender: 'pauseDurationStandard' },
          align: 'center'
        },
        {
          title: '备注',
          dataIndex: 'notes',
          width: 150,
          scopedSlots: { customRender: 'notes' },
          align: 'center'
        },
        {
          title: '工作时长',
          dataIndex: 'workingHours',
          width: 150,
          scopedSlots: { customRender: 'workingHours' },
          align: 'center'
        },
        {
          title: '操作',
          width: 100,
          dataIndex: 'operation',
          scopedSlots: { customRender: 'operation' },
          stickyFixed: 'right'
        }
      ],
      // 表格多选
      selectedRowKeys: [],
      selectedRows: [],
      rowSelection: {
        onChange: (selectedRowKeys, selectedRows) => {
          this.selectedRowKeys = selectedRowKeys
          this.selectedRows = selectedRows
        },
        onSelect: (record, selected, selectedRows) => {},
        onSelectAll: (selected, selectedRows, changeRows) => {}
      },
      shiftsHeadIdListOption: [], // 班次名称
      scrollWdith: 1000
    }
  },
  created () {
    this.getShiftsHeadIdList()
  },
  mounted () {
    this.onSearch()
  },
  methods: {
     // 表单搜索
     onSearch () {
      this.isEdit = false
      this.$refs.dataTable.searchParams = this.queryParams;
      this.$refs.dataTable.getData();
    },
    // 标准停顿时长（分）
    pauseDurationStandardChange (val, record) {
      this.getWorkingHours("wh", "wh", val, record)
    },
    // 终止时间
    endTimeShiftsOnChange (time, timeString, record) {
      record.endTimeShifts = this.moment(timeString, 'HH:mm:ss')
      this.getWorkingHours(record.startTimeShifts, time, record.pauseDurationStandard, record)
    },
    // 起始时间
    startTimeShiftsOnChange (time, timeString, record) {
      record.startTimeShifts = this.moment(timeString, 'HH:mm:ss')
      this.getWorkingHours(time, record.endTimeShifts, record.pauseDurationStandard, record)
    },
    getWorkingHours (val1, val2, val3, record) {
      if (!val1 || !val2) {
        return
      }
      const params = {
        startTimeShifts: String(this.$moment(val1 === "wh" ? record.startTimeShifts : val1).format('YYYY-MM-DD HH:mm:ss')),
        endTimeShifts: String(this.$moment(val1 === "wh" ? record.endTimeShifts : val2).format('YYYY-MM-DD HH:mm:ss')),
        pauseDurationStandard: String(val3)
      }
      record.workingHours = calculateTimeDifference(params.startTimeShifts, params.endTimeShifts, params.pauseDurationStandard)
    },
    moment,
    // 新增行
    handleAddLine () {
      const list = JSON.parse(JSON.stringify(this.$refs.dataTable.myDataSource))
      this.isEdit = true
      const obj = {
        id: "add",
        startTimeShifts: "",
        endTimeShifts: "",
        pauseDurationStandard: 0,
        notes: "",
        workingHours: ""
      }
      this.currentId = "add"
      list.unshift(obj)
      this.$refs.dataTable.myDataSource = list
    },
    // 删除
    handleDelete (record) {
      const self = this
      this.$confirm({
        title: '警告',
        content: `真的要删除 id为${record.id}的数据项吗?`,
        okText: '删除',
        okType: 'danger',
        cancelText: '取消',
        onOk () {
          apiRoutingCalendarRemoveShifts(record.id).then(response => {
            if (response.code === 200) {
              self.$message.success('删除成功!')
              self.onSearch()
            } else {
              self.$message.error(response.msg)
            }
          })
        }
      })
    },
    getShiftsHeadIdList () {
      apiRoutingCalendarShiftsPullDownList().then(res => {
        if (res.code === 200 && res.data && res.data.length > 0) {
          this.queryParams.shiftsHeadId = res.data[0].realValue
          this.shiftsHeadIdListOption = res.data
          this.shiftsHeadIdOnChange(res.data[0].realValue)
          this.onSearch()
        }
      })
    },
    // 班次名称
    shiftsHeadIdOnChange (val) {
      this.queryParams.description = this.shiftsHeadIdListOption.find(item => val === item.realValue).bringOutDataOne
    },
    /** 查询快码类型列表 */
    getList (data) {
      this.typeList = data
      this.isEdit = false;
    },
    // 新增/修改框事件
    handleOk () {
      this.onSearch()
      this.getShiftsHeadIdList()
    },
    /** 搜索按钮操作 */
    handleQuery () {
      this.onSearch()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParams = {
        shiftsHeadId: undefined,
        description: undefined
      }
      this.handleQuery()
    },
    // 编辑
    handleEdit (record) {
      if (this.currentId && record.id !== this.currentId && this.isEdit) {
        this.$message.warning('请保存上次编辑的数据')
        return;
      }
      // record.endTimeShifts = this.$moment(record.endTimeShifts)
      this.isEdit = true;
      this.currentId = record.id;
    },
    // 编辑-保存
    handleSave (record) {
      if (!record.startTimeShifts || !record.endTimeShifts || !record.workingHours) {
        this.$message.warning('必填项不能为空')
        return;
      }
      const obj = JSON.parse(JSON.stringify(record))
      obj.shiftsHeadId = this.queryParams.shiftsHeadId
      if (obj.id === "add") {
        delete obj.id
      }
      // 时间格式处理
      obj.startTimeShifts = this.$moment(obj.startTimeShifts).format('1970-01-01 HH:mm:ss')
      obj.endTimeShifts = this.$moment(obj.endTimeShifts).format('1970-01-01 HH:mm:ss')

      const params = []
      params.push(obj)
      apiRoutingCalendarAddShifts(params).then(response => {
        if (response.code === 200) {
          this.$message.success('保存成功')
          this.onSearch()
          this.isEdit = false;
        } else {
          this.$message.error(response.msg)
        }
      })
    },
    // 取消
    handleCancel (record) {
      this.isEdit = false
      this.onSearch()
     }
  }
}
</script>

<style scoped lang="less">
.page-header-content{
  input {
    width: 150px;
  }
  /deep/.ant-select{
    width: 150px;
  }
}
/deep/.ant-input-number{
  width: 150px;
}
</style>
